import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { PillTabData } from "../../../../Data/UiKits/Tabs";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";

const PillTabContent: React.FC<SimpleTabContentProp> = ({ tabId }) => {
  return (
    <TabContent activeTab={tabId}>
      {PillTabData &&
        PillTabData.map((item, index) => (
          <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
};
export default PillTabContent;
